<!--
 * @Author: Gaho
 * @Date: 2024-04-18 14:38:10
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-24 16:40:54
 * @Description: 
-->
<template>
    <CasinoHistoryBodyCell
        @click="userModalControl(history?.user?._id)"
        class="md:flex-[0.6] sm:flex-[1] flex cursor-pointer"
    >
        <div class="flex gap-1">
            <div class="relative w-[24px] h-[24px]">
                <UserAvatar
                    size="24px"
                    :src="history?.user?.avatar"
                />
                <span class="bg-[#ed1d49] text-white text-center text-xs font-semibold w-[19px] h-[12px] transform -translate-x-1/2 rounded-xl absolute left-[50%] top-[75%]" >
                    {{ history?.user?.lvl }}
                </span>
            </div>
            <span class="ellipsis flex-1">
                {{ history?.user?.name }}
            </span>
        </div>
    </CasinoHistoryBodyCell>
    <CasinoHistoryBodyCell
        class="inline-flex sm:flex-[1] md:flex-[0.6]"
    >
        <span 
            class="bg-[#2a3546] ellipsis rounded-3xl px-2"
            :style="{ 'color': history.sector === 'gray' ? 'rgb(110, 129, 160)' : colors[history.sector] }"
        >{{
            `x${Number(history.multi).toFixed(3)}`
        }}</span>
    </CasinoHistoryBodyCell>

    <CasinoHistoryBodyCell class="md:flex-[0.6] sm:flex-[1]">
        <CasinoHistoryCoinContent
            :history="history"
            :currency-name="history.currency"
            :amount="Number(getFixed(Number(history.amount)))"
            validate-number-calss="text-[#ffffff]"
        />
    </CasinoHistoryBodyCell>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { colors } from '@/components/Casino/History/GameContent/Circle.vue';
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        default: () => ({}),
    },
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    userModalControl: Function,
    seeRoundDetail: Function,
});


</script>
